import DataFetcher from "./data-fetcher";
import endpoints from "./endpoints";
export default async function fetchEnumsData() {
    return DataFetcher.fetchJson(endpoints.enumsData);
}
export function getCachedEnumsData() {
    return DataFetcher.getCachedJson(endpoints.enumsData);
}
